import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobal } from '../Global/GlobalProvider';
import { OpsMenu } from './OpsMenu';
import { FiLogOut } from 'react-icons/fi';

const MainMenu = ({ resetMenu }) => {

     const [ currentMenu, setCurrentMenu] = useState([]); // start with main menu
     const [ previousMenus, setPreviousMenus] = useState([]); // to keep track of navigation
     const [ menuOptions, setMenuOptions ] = useState([])
     const { masterMenu, UserData, logout } = useGlobal();
     const navigate = useNavigate();

     useEffect( () => {

          if (UserData?.userKey) {

               const mo = [
                    {
                         key: "0",
                         // link: "/folders",
                         title: 'Main Menu',
                         noArrow: true,
                         
                    },
                    // {
                    //      key: "0.0.1",
                    //      link: "/dashboard",
                    //      label: 'Dashboard',
                    //      icon: <FaGripLines/>,
                    // },
                    ...OpsMenu(),
                    // ...HrMenu(),
                    // ...CrmMenu(),
                    // ...FinanceMenu(),
               ]

               
               setMenuOptions(mo)
               setCurrentMenu(mo)

          }
          

     }, [UserData, resetMenu, masterMenu])

     const findMenuOption = (menuOptions, selectedKey) => {
          for (let option of menuOptions) {
            if (option.key === selectedKey) {
              return option;
            }
            if (option.innerMenu) {
              const foundOption = findMenuOption(option.innerMenu, selectedKey);
              if (foundOption) {
                return foundOption;
              }
            }
          }
          return null;
        };
        
        const handleMenuClick = (selectedKey) => {
          const selectedOption = findMenuOption(menuOptions, selectedKey);
        
          
          if (selectedOption && selectedOption.innerMenu) {
            setPreviousMenus([...previousMenus, currentMenu]); // push current menu to history
            setCurrentMenu(selectedOption.innerMenu); // set inner menu as current
          }
        };

     const handleBackClick = () => {
          const lastMenu = previousMenus.pop(); // get the last menu from history
          setCurrentMenu(lastMenu); // set it as the current menu
          setPreviousMenus([...previousMenus]);
     }

     return (
     <div>

          <div style={{paddingLeft: 10, cursor: 'pointer'}} onClick={() => { navigate('/bookings/Delivered') }}>
               <img src="/images/opexlogo-transparent.png" style={{width: 150, marginLeft: 20, marginTop: 20}}/>
          </div>
          
          <Menu mode="inline" style={{paddingTop: 15}} onClick={(e) => handleMenuClick(e.key)}>
          {currentMenu.map(option => { 
               if (option.divider) {
                    return (
                    <div key={option.key} 
                    style={{
                         borderBottom: '1px solid #f1f1f1',
                         marginLeft: 20, marginRight: 20, marginTop: 15, marginBottom: 15
                    }}>
                    </div>
                    )
               }
               else if (option.title) {
                    return (
                         <div key={option.key} style={{color: '#fff', paddingLeft: 20, marginTop: 30, marginBottom: 30}}>
                         <h2 style={{marginBottom:40}}>
                              { !option.noArrow && 
                              <ArrowLeftOutlined onClick={handleBackClick} style={{cursor: 'pointer', marginRight: 30}}/>  }
                              {option.title}
                         </h2>
                         </div>
                    )
               } else {
                    return (
                         <Menu.Item key={option.key} style={{paddingLeft: 10}} icon={
                              option.profile ? <div className="profilePic">{option.icon}</div> : <div><div className="menuicon">{option.icon}</div></div> }>
                         { option.link ?
                         <Link to={option.link}>{option.label}</Link>
                         : option.label }
                         </Menu.Item>
                    )}
               }
          )}
               <Menu.Item key={"logout"} style={{paddingLeft: 10}} icon={
                    <div><div className="menuicon"><FiLogOut/></div></div> }>
                    <Link onClick={() => { logout() } }>Log out</Link>
               </Menu.Item>
          </Menu>
     </div>
  );
}

export default MainMenu;
